import handleCart from './handleCart'
import ui from './ui'
import { combineReducers } from "redux";
const rootReducers = combineReducers({
    handleCart,
    ui,
})
export default rootReducers
